<template>
  <div>
    <div class="col-xs-12">
      <p>{{ trans('subscription.eventseries.explanation_parameters') }}</p>
    </div>

    <div
      class="col-sm-12"
      style="display: inline-block; margin-bottom: 10px;"
    >
      <label
        class="col-sm-3"
        style="margin-top: 15px;"
        for="goal_name"
      >{{ trans('core.name') }}</label>
      <div
        class="col-sm-9"
        style="padding-right: 0;"
      >
        <input
          id="goal_name"
          v-model="goalName"
          class="col-sm-9 form-group form-control"
        >
      </div>
    </div>

    <div
      class="col-xs-12"
      style="display:flex; flex-wrap:wrap; flex: 1 0 auto"
    >
      <a
        v-for="subscribable in subscribables"
        :id="subscribable.id"
        :class="'course-block' + (selectedSubscribableId === subscribable.id ? ' course-block-selected' : '')"
        @click="selectSubscribable(subscribable)"
      >
        <span style="font-weight:bold;">{{ subscribable.name }}</span>
      </a>
    </div>

    <br style="clear:both">

    <div
      v-show="errors != null"
      class="errors subscribable-details"
      style="border-color: red"
    >
      <h5>{{ trans('errors.message.occurred') }}</h5>
      <ul>
        <li v-for="error in errors">
          {{ error }}
        </li>
      </ul>
    </div>

    <subscribable-parameters
      v-if="selectedSubscribableId !== null"
      :subscribable-id="selectedSubscribableId"
    />
  </div>
</template>

<script>
import Suggest from './../Suggest.vue'
import FormGroup from './../../lecturer-flow/components/FormGroup.vue'
import SubscribableParameters from './SubscribableParameters.vue'

export default {

  name: 'Subscribables',
  components: { Suggest, FormGroup, SubscribableParameters },

  props: {
    errors: {
      default: null,
    },
  },

  data () {
    return {
      selectedSubscribableId: null,
    }
  },

  computed: {
    subscribables () {
      return this.$store.state.eventSerieSubscribables.subscribables
    },
    subscribableIds () {
      return Object.keys(this.subscribables)
    },

    goalName: {
      get () {
        return this.$store.state.eventSeries.serie_rules.goal_name
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'goal_name', value: newValue })
      },
    },
  },

  created () {
    if (this.subscribableIds.length !== 0) {
      this.selectedSubscribableId = this.subscribableIds[0]
    }
    this.$emit('canFinishStep')
  },

  methods: {
    selectSubscribable (subscribable) {
      this.selectedSubscribableId = subscribable.id
    },
  },
}
</script>

<style>
    .course-block {
        margin-right: 5px;
        margin-top: 2px;
        padding: 8px;
        border: 1px solid lightgray;
        cursor: pointer;
        color: black;
        font-weight: bold;
    }

    .course-block:hover {
        color: black;
        border: 2px solid #25167a !important;
    }

    .course-block-selected {
        border: 2px solid #25167a !important;
        background-color: lightgray;
    }

    .btn-primary {
        background-color: #25167a !important;
    }

</style>
